// extracted by mini-css-extract-plugin
export default {"desktopScreen":"(min-width:1440px)","tabletScreen":"(min-width:768px) and (max-width:1439px)","mobileScreen":"(max-width:767px)"};